// @flow
// $FlowFixMe
import React, { useMemo, Fragment } from "react";
import buildColor from "@fdr/static-ui/ColorPalette";
import { isNumber } from "lodash";
import CountUpAnimation from "./CountUpAnimation";

import {
  Container,
  PercentageHalfCircle,
  HalfCircle,
  PercentageText
} from "./styled-components";

type Props = {
  width: number,
  percent: number | string,
  barColor: string,
  textColor: string,
  total: number,
  isPercentage: boolean,
  index: number,
  strokeWidth: number,
  fontSize: number,
  hasStrokeAnimation: boolean,
  hasValueAnimation: boolean
};

const HalfCircleValue = (props: Props) => {
  const {
    percent,
    width,
    barColor,
    textColor,
    total,
    isPercentage,
    index,
    strokeWidth,
    fontSize,
    hasStrokeAnimation,
    hasValueAnimation
  } = props;

  const showPercentage = (percentage: number | string) =>
    isNumber(percentage) ? (
      <Fragment>
        {hasValueAnimation ? (
          <Fragment>
            <CountUpAnimation duration={600} value={percentage} />%
          </Fragment>
        ) : (
          `${percentage}%`
        )}
      </Fragment>
    ) : (
      percentage
    );

  return useMemo(
    () => (
      <Container
        key={`${percent}-${total}-${index}`}
        viewBox="0 0 100 50"
        width={width}
      >
        <g fillOpacity="0" strokeWidth={strokeWidth}>
          <HalfCircle d="M5 50a45 45 0 1 1 90 0" />
          <PercentageHalfCircle
            d="M5 50a45 45 0 1 1 90 0"
            barColor={barColor}
            percent={isNumber(percent) ? percent : 0}
            hasStrokeAnimation={hasStrokeAnimation}
          />
        </g>
        <PercentageText x="50" y="50" textColor={textColor} fontSize={fontSize}>
          {isPercentage ? (
            showPercentage(percent)
          ) : (
            <Fragment>
              {isNumber(percent) && hasValueAnimation ? (
                <CountUpAnimation duration={600} value={Math.round(+percent)} />
              ) : (
                `${isNumber(percent) ? Math.round(+percent) : percent}`
              )}
            </Fragment>
          )}
        </PercentageText>
      </Container>
    ),
    [percent, isPercentage, width, textColor, barColor, strokeWidth, fontSize]
  );
};

HalfCircleValue.defaultProps = {
  width: 100,
  percent: 0,
  barColor: buildColor("blue"),
  textColor: buildColor("black"),
  total: 100,
  isPercentage: true,
  index: 0,
  strokeWidth: 5,
  fontSize: 22,
  hasStrokeAnimation: true,
  hasValueAnimation: true
};

export default HalfCircleValue;
